export default "__VITE_ASSET__CgNdfOsh__"